module.exports = __webpack_public_path__ + "img/whiteboard.23aa4510.svg";